package fr.frux.shared.data.local

import dev.zacsweers.metro.ContributesTo
import dev.zacsweers.metro.Provider
import dev.zacsweers.metro.Provides
import dev.zacsweers.metro.SingleIn
import fr.frux.core.common.di.AppScope
import fr.frux.core.database.FruxDatabase
import fr.frux.core.database.localDatabaseSupported
import kotlin.time.Clock

/**
 * Fourniture de la persistance locale du referentiel d'especes (#177), meme motif que
 * [TreeLocalDataSourceModule] : la base n'est dereferencee que si la cible a un driver SQLite,
 * sinon [NoOpSpeciesLocalDataSource] (web = reseau seul).
 */
@ContributesTo(AppScope::class)
interface SpeciesLocalDataSourceModule {
    companion object {
        @Provides
        @SingleIn(AppScope::class)
        fun provideSpeciesLocalDataSource(database: Provider<FruxDatabase>): SpeciesLocalDataSource =
            if (localDatabaseSupported) {
                SqlDelightSpeciesLocalDataSource(database()) { Clock.System.now().toEpochMilliseconds() }
            } else {
                NoOpSpeciesLocalDataSource
            }
    }
}
